//-import Lenis from 'lenis';
import { components } from '../components/_components.js';
import { nav } from './_nav.js';
import { langSelectors } from '../components/_langSelector.js';
let Block = {
	top: 0,
	show: 0
}
let $this;
let $html;
let Brand = {
	"top": 0,
	"id": ""
};
let brands = [];
export class Scroll {
	constructor(){
		$this = this;
		$html = document.documentElement;
		this.topD = 0;
		this.btmD = this.topD + window.innerHeight;
		this.animations = new Array();
		this.blocks 	= new Array();
		this.observer;
		this.brandObserver;
		this.brandNav = document.querySelectorAll(".c-list_categories li a");
		
		this.start();
	}
	
	start(){
		let $this = this;
		//this.startLenis();
		this.reloadObserver();
		components.init();
		langSelectors.init();
		nav.active( this.lenis );
		document.addEventListener("scroll", function(){
			$this.topD = window.pageYOffset;
			$this.checkScroll();
		}, false);
	}
	resize(){
		brands = [];
		let $brandSections = document.querySelectorAll(".s-brands");
		if( $brandSections.length > 0 ){
			let $headerH = document.querySelector("#global_header").clientHeight;
			let $navH = document.querySelector(".c-list_categories").clientHeight;
			$brandSections.forEach( ($b, index) => {
				let _b = Object.create(Block);
				_b.top = Math.floor( $b.getBoundingClientRect().top + window.pageYOffset - $headerH - $navH );
				_b.id = $b.getAttribute("id");
				brands.push(_b);
			});
		}
	}
	
	reloadObserver(){
		let $this = this;
		if($this.observer){
			$this.observer.disconnect();
		}
		this.setObserver(null);
	}
	
	setObserver(root){
		let $this = this;
		let $animates = document.querySelectorAll("[data-animate]");
		if( $animates ){
			//DOMにdata-repeat="1"で画面外にいったときにanimateのclassを削除
			let AnimateOptions = {
				root: root ? root : null,
				rootMargin: "-33% 0px",
				threshold: 0
			}
			//data-animate用observer
			$this.observer = new IntersectionObserver($this.checkAnimate, AnimateOptions);
			//console.log($animates, AnimateOptions, $this.observer);
			$animates.forEach( item => {
				$this.observer.observe(item);
			});
		}
	}
	checkAnimate(items){
		items.forEach( (item) => {
			if( item.isIntersecting ){
				startAnimate( item.target );
			}else{
				if( item.target.getAttribute("data-repeat") === "1" ){
					deleteAnimate(item.target);
					
				}
			}
		});
		
		function startAnimate( $target ){
			if( !$target.classList.contains("animate") ){
				$target.classList.add("animate");
			}
		}
		function deleteAnimate( $target ){
			if( $target.classList.contains("animate") ){
				$target.classList.remove("animate");
			}
		}
	}
	checkScroll(){
		let topD = this.topD;
		if( topD >= window.innerHeight/2 ){
			if( !$html.classList.contains("scrolled") ){
				$html.classList.add("scrolled");
			}
		}else{
			if( $html.classList.contains("scrolled") ){
				$html.classList.remove("scrolled");
			}
		}
		for( let i = 0; i < brands.length; i++ ){
			let b = brands[i];
			if( i === brands.length - 1 ){
				if( topD >= b.top ){
					$this.activeBrand(i);
				}
			}else{
				if( topD >= b.top && topD < brands[i + 1].top ){
					$this.activeBrand(i);
				}
			}
		}
	}
	activeBrand(i){
		let currentNav = $this.brandNav[i];
		
		if( !currentNav.classList.contains("active") ){
			$this.brandNav.forEach( (n) => { n.classList.remove("active") });
			currentNav.classList.add("active");
		}
	}
	getTop($dom, offset){
		let t = Math.floor( $dom.getBoundingClientRect().top + window.pageYOffset );
		return [ t, Math.floor( t + offset )]
	}
}